export function getQueryStringParam(param: string): boolean {
  const search = new URLSearchParams(window.location.search);
  return search.get(param) === "true";
}

export function doesQueryStringParamExist(param: string): boolean {
  const search = new URLSearchParams(window.location.search);
  return search.get(param) !== null;
}
